import { render, staticRenderFns } from "./SubvendorSelect.vue?vue&type=template&id=0d5fe657"
import script from "./SubvendorSelect.vue?vue&type=script&lang=js"
export * from "./SubvendorSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1662581811/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d5fe657')) {
      api.createRecord('0d5fe657', component.options)
    } else {
      api.reload('0d5fe657', component.options)
    }
    module.hot.accept("./SubvendorSelect.vue?vue&type=template&id=0d5fe657", function () {
      api.rerender('0d5fe657', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/features/promotions/SubvendorSelect.vue"
export default component.exports